<!-- 协议查看 -->
<template>
  <div class="agreement">
    <div class="content" v-if="code === 'sensitive'">
      <div class="title">敏感个人信息处理事宜授权书</div>
      <div class="tips">本授权书是您与光子易就敏感个人信息处理事宜出具的授权书，为了维护您的权益，请在勾选同意本授权书前，仔细阅读本授权书各条款，在确认充分了解后慎重决定是否同意本授权书。勾选同意本授权书意味着您已知悉本授权书所有内容以及由此产生的法律效力，根据您的真实意思表示自愿作出授权。</div>
      <div class="text">
        <p>一、目的及类型</p>
        <p>为了（1）向您提供光子易的服务（包括但不限于收款服务、付款服务、提现服务、汇兑服务等）；（2）根据适用的法律法规和监管规定以及我们自行制定的合规、风控要求；（3）验证您的重要操作行为（如：找回或修改密码、开具账户和资金相关凭证、冻结您的光子易账户资金、注销您的光子易账户）；（4）为了解决您使用光子易服务过程中所遇到的相关问题。</p>
        <p>我们需要收集您的有效身份信息、银行账户信息，用于核验您的身份及向您提供服务。 </p>
        <p class="mt-20">二、存储</p>
        <p>1.存储地点: 本次获取和处理的敏感个人信息将存储于中华人民共和国香港特别行政区。</p>
        <p>2.存储期限: 我们只会在达成本授权函所述目的和适用法律法规及监管规定的最短期限内保留您的个人信息，除非需要延长保留期或受到适用法律法规的允许。我们将严格落实数据存储期限最小、必要原则，如相关数据不再具有存储使用必要及法律限制的，我们将及时采取数据删除或者匿名化处理等措施。</p>
        <p class="mt-20"> 三、您的权利</p>
        <p>在我们处理您敏感个人信息的活动中，您享有如下权利:</p>
        <p>一般而言，您可以通过“银行卡管理”的页面路径，查阅、删除您的银行账户及相关个人信息。 </p>
        <p class="mt-20">四、风险提示</p>
        <p>1.有效身份信息、银行账户信息为您的敏感个人信息。一旦泄露或者非法使用，可能导致人格尊严受到侵害或者人身、财产安全受到危害等。</p>
        <p>2.我们承诺对您的个人信息严格保密，并按照适用法的规定，采取符合业界标准、合理可行的安全防护措施保护您提供的个人信息安全，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。</p>
        <p>我们会采取合理可行的措施，尽力避免收集无关的个人信息。我们只会在达成《隐私政策》所述目的和适用法律法规及监管规定的最短期限内保留您的个人信息，除非需要延长保留期或受到适用法律法规的允许。我们将严格落实数据存储期限最小、必要原则，如相关数据不再具有存储使用必要及法律限制的，我们将及时采取数据删除或者匿名化处理等措施。 </p>
        <p class="mt-20">五、其他事项</p>
        <p>如您对本授权书内容有任何疑问、意见或建议，可以通过support@photonpay.com与我们取得联系。 </p>
        <p class="mt-20">如有本授权书未尽事项，请您查看我们<span @click="open()">《隐私政策》</span>。</p>
      </div>
    </div>
    <div class="content" v-if="code === 'promotion'">
      <PromotionAgreement />
    </div>
  </div>
</template>

<script>
import PromotionAgreement from '@/components/home_components/promotionAgreement.vue'
export default {
  name: 'agreement',
  components: {
    PromotionAgreement
  },
  data() {
    return {
      code: ''
    }
  },
  mounted() {
    const {code} = this.$route.query
    this.code = code
  },
  methods: {
    open() {
      window.open('https://www.photonpay.com/policy/agreement/20210623162857620')
    }
  }

}
</script>
<style lang="less" scoped>
.agreement{
  padding: 0 25px;
}
.content{
  padding: 27px 0px;
  background: #fff;
  border-radius: 12px;
  color: #302b3e;
  height: calc(100% - 32px - 150px);
}
.mt-20{
  margin-top: 20px;
}
.bold{
  font-weight: 600;
}
.pl-15{
  padding-left: 15px;
}
.title{
  font-size: 16px;
  font-weight: 600;
  color: #302b3e;
  line-height: 20px;
  text-align: center;
}
.tips{
  font-size: 14px;
  font-weight: 600;
  color: #302b3e;
  line-height: 20px;
  margin-top: 16px;
}
.text{
  font-size: 12px;
  color: #666666;
  line-height: 18px;
  margin-top: 16px;
}
.btn{
  height: 40px;
  width: calc(100vw - 110px);
  margin: 0 auto;
  background: #ffb600;
  border-radius: 40px;
  margin-top: 40px;
  font-size: 16px;
  color: #302b3e;
  line-height: 20px;
  text-align: center;
  line-height: 40px;
}
.btn-text{
  text-align: center;
  margin-top: 22px;
  color: #666666;
  font-size: 16px;
}
p{
  line-height: 20px;
}
</style>
